/**
 * Plus- en minknoppen naast het aantalveld.
 *
 * Bewust geen web component: het is een handvol knoppen binnen een formulier
 * dat ook zonder JS werkt, want het getalveld is een gewone number-input.
 *
 * Dit is NIET hetzelfde als de plus- en minknoppen in de winkelwagen. Daar zit
 * de regel al in de winkelwagen en gaat elke klik via /cart/change.js naar
 * Shopify (zie cart.js, data-cart-change). Hier bestaat de regel nog niet: het
 * aantal wordt pas meegestuurd bij verzenden. Twee mechanismen dus, om twee
 * verschillende redenen. Voeg ze niet samen.
 */
document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-quantity]");
  if (!button) return;

  const input = button.parentElement.querySelector("[data-quantity-input]");
  if (!input) return;

  const step = Number(button.dataset.quantity);
  const min = Number(input.min || 1);
  input.value = String(Math.max(min, (Number(input.value) || min) + step));
  input.dispatchEvent(new Event("change", { bubbles: true }));
});
